<template>
    <div class="all-servers-table-container">
        <sidebar
            :sidebar-dashboard="true"
            class="all-servers-table-container__sidebar"
        ></sidebar>
        <creator-name
            class="all-servers-table-container__creator-name"
        ></creator-name>
        <div class="all-servers-table-container__summary-table">
            <div class="return">
                <button-back class="return__button-return"></button-back>
            </div>
            <div class="summary-data-table__title">Summary</div>
            <div class="all-data-server-table">
                <Table
                    :columns="[
                        'Type',
                        'Provider',
                        'Game name',
                        'Players',
                        'Peak (24)',
                        'Expiration',
                        'Running time',
                    ]"
                    :data="
                        filteredServers && filteredServers.length > 0
                            ? filteredServers
                            : null
                    "
                    :cell-style="
                        'display: grid; grid-template-columns: 2fr 2fr 3fr 2fr 2fr 2fr 2fr; grid-template-rows: 4rem;'
                    "
                    :data-elements="[
                        'type',
                        'provider',
                        'gameName',
                        'players',
                        'peak',
                        'expiration',
                        'runningTime',
                    ]"
                    :is-loading="getLoading"
                    :no-title="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from '@/components/sidebar/index';
import CreatorName from '@/components/dashboard/sections/DashboardCreatorName';
import { mapActions, mapGetters } from 'vuex';
import ButtonBack from '@/components/common/ButtonBack.vue';
import Table from '@/components/common/Table.vue';

export default {
    name: 'AllServersTable',
    components: {
        Sidebar,
        CreatorName,
        ButtonBack,
        Table,
    },
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        ...mapGetters('module_servers', {
            getLoading: 'getLoading',
            filteredServers: 'getFilteredServers',
        }),
    },
    created: function() {
        this.fetchServers();
    },
    methods: {
        ...mapActions('module_servers', ['fetchServers']),
    },
};
</script>

<style scoped lang="scss">
.all-servers-table-container {
    @include main-grid-container;
    &__sidebar {
        grid-column: col-start / span 3;
        grid-row: auto;
        height: 100%;
    }
    &__creator-name {
        grid-column: col-start 4 / 13;
        grid-row: 1;
        @media (max-width: $sm-up) {
            grid-column: col-start / 13;
            margin-top: 3rem;
        }
    }
    &__summary-table {
        margin-top: -730px;
        grid-column: col-start 4 / 13;
        grid-row: 3;
        background: $white-main;
        height: 100%;
        width: 100%;
        @media (max-width: $lg-up) {
            grid-column: col-start / 13;
            margin: 9rem auto 4rem auto;
        }

        .return {
            padding-left: 55px;

            @media (max-width: $sm-up) {
                padding-left: 45px;
            }
            @media (min-width: $xxs-up) and (max-width: $xs-up) {
                padding-left: 35px;
            }
        }
    }
}
.b-button {
    &__button-return {
        margin: auto auto 2rem 3rem;
    }
}
.summary-data-table {
    margin-bottom: 10rem;
    @media (min-width: $xxs-up) and (max-width: $xl-up) {
        margin: 3rem auto 3rem 3rem;
        width: 90%;
        position: static;
        bottom: 0;
        right: 0;
        overflow-x: auto;
    }
    &__title {
        margin: 2rem auto 2rem 3rem;
        width: 308px;
        height: 44px;
        color: $blue-main;
        font-family: $istok-font;
        font-size: 36px;
        font-weight: 700;
        letter-spacing: 0.57px;
        line-height: 53px;
    }
}
</style>
<style lang="scss">
.all-data-server-table {
    .generic-table {
        width: 90%;
        margin-left: 50px;
        @media (max-width: $xs-up) {
            margin: 0 auto;
        }

        .cont {
            @media (max-width: $sm-up) {
                width: 1100px;
            }

            .rowCell {
                @media (max-width: $xs-up) {
                    min-width: 100px;
                }
            }
        }
    }
}
</style>
